import React, { Component } from "react";

import {
  CSpinner,
  CBadge,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CButton,
  CCollapse,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CRow,
  CCol,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSelect,
  CSwitch,
  CTabs,
  CNav,
  CNavItem,
  CNavLink
} from "@coreui/react";
import { Form } from "react-bootstrap";
import ReactDOM from "react-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiCheckDoubleFill
} from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Col, Label, Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { groupAllocations } from "../../../../utils/allocation";
import { friendlyDate } from "../../../../utils/date";

import "./style.css";

const appRoot = document.getElementById("root");

class EvaluationBankAllocate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      allocateList: [],
      // user: [],
      // hierarchy: [],
      groups: undefined,
      regions: undefined,
      schools: undefined,
      activity_id: this.props.match.params.id,
      loading: true,
      allocating: false,
      show: null,
      delete_id: null,
      group_id: null,
      region_id: null,
      school_id: null,
      serie_id: null,
      start_allocation: undefined,
      end_allocation: undefined,
      class: "null",
      mine: false,
      homework: false,
      content: 0
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  fetchData(communityOnly = false) {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ loading: true });

    let objAllocate = {
      activity_id: this.state.activity_id,
      room_id: 0,
      user_id: 0
    };

    let currYear = new Date().getFullYear();

    axios
      .all([
        axios.get(`${URL.api}community/room/listAllocationByFilter`, {
          params: {
            group_id: this.state.group_id,
            region_id: this.state.region_id,
            school_id:
              this.state.school_id ?? this.props.general.active_roles.school_id,
            series: this.state.serie_id
              ? JSON.stringify([this.state.serie_id])
              : null,
            user_id: this.props.user.user.id,
            role_id: this.props.general.active_roles.role_id,
            class: !communityOnly,
            start: `${currYear}-01-01`,
            end: `${currYear}-12-30`
          },
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}activity/allocate/list`, objAllocate, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(
          `${URL.api}activity/activity/singleView/${this.state.activity_id}`,
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        ),
        axios.get(`${URL.api}classification/serie/list`, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (resp, respAllocate, respActivity, respSeries) => {
            let list = [];
            let allocation = respAllocate.data.data;
            for (let i = 0; i < resp.data.data.length; i++) {
              let obj = {
                allocation_id: 0,
                room_id: resp.data.data[i].id,
                room_name: resp.data.data[i].name,
                room_id_external: resp.data.data[i].external_id,
                room_school_id: resp.data.data[i].school_id,
                room_school_name: resp.data.data[i].school_name,
                room_region_id: resp.data.data[i].region_id,
                room_region_name: resp.data.data[i].region_name,
                room_group_id: resp.data.data[i].group_id,
                room_group_name: resp.data.data[i].group_name,
                release: false,
                homework: false,
                start_allocation: "",
                end_allocation: "",
                originalStart: "",
                originalEnd: "",
                originalHomework: false,
                allocatedUserIds: [],
                users: [],
                show: false,
                class: resp.data.data[i].class,
                students_count: resp.data.data[i]?.students_count
              };

              for (let j = 0; j < allocation.length; j++) {
                if (allocation[j].room_id === obj.room_id) {
                  obj.allocation_id = allocation[j].id;
                  obj.release = allocation[j].release;
                  obj.homework = allocation[j].homework;
                  obj.start_allocation = `${
                    allocation[j].start.split(" ")[0]
                  }T${allocation[j].start.split(" ")[1]}`;
                  obj.end_allocation = `${allocation[j].end.split(" ")[0]}T${
                    allocation[j].end.split(" ")[1]
                  }`;
                  obj.originalStart = obj.start_allocation;
                  obj.originalEnd = obj.end_allocation;
                  obj.originalHomework = obj.homework;
                  obj.allocatedUserIds = allocation[j].users.map(
                    user => user.user_id
                  );
                }
              }

              list.push(obj);
            }

            let hierarchy = groupAllocations(resp.data.data);
            let hierarchyIndexList = [];
            let hierarchyList = [];
            for (let i = 0; i < hierarchy?.length; i++) {
              if (!hierarchyIndexList.includes(hierarchy[i].group_id)) {
                hierarchyIndexList.push(hierarchy[i].group_id);
                hierarchyList.push(hierarchy[i]);
              }
            }
            this.setState({
              list,
              // allocation,
              series: respSeries.data.data,
              // hierarchy: hierarchyList,
              activity: respActivity.data.data,
              loading: false
            });
          },
          error => {
            this.error("Não foi possível obter as informações da alocação");
          }
        )
      );
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    if (
      this.props.user.user_roles[0].role_id === 1 ||
      this.props.user.user_roles[0].role_id === 2 ||
      this.props.user.user_roles[0].role_id === 3 ||
      this.props.user.user_roles[0].role_id === 4
    ) {
      this.getRegions(this.props.general.active_roles.group_id);
      this.getSchools(
        this.props.general.active_roles.group_id,
        this.props.general.active_roles.region_id
      );
      axios
        .all([
          axios.get(
            `${URL.api}activity/activity/singleView/${this.state.activity_id}`,
            { headers: { Authorization: `Bearer ${this.props.user.token}` } }
          ),
          axios.get(`${URL.api}access/group/list`, {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          }),
          axios.get(`${URL.api}classification/serie/list`, {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          })
        ])
        .then(
          axios.spread(
            (respActivity, respGroups, respSeries) => {
              this.setState({
                series: respSeries.data.data,
                groups: respGroups.data.data,
                activity: respActivity.data.data,
                group_id: this.props.general.active_roles.group_id
                  ? this.props.general.active_roles.group_id
                  : 0,
                region_id: this.props.general.active_roles.region_id
                  ? this.props.general.active_roles.region_id
                  : 0,
                school_id: this.props.general.active_roles.school_id
                  ? this.props.general.active_roles.school_id
                  : 0
              });
            },
            error => {
              this.error("Não foi possível obter as informações da alocação");
            }
          )
        );
    }
    if (
      this.props.general.active_roles.group_id &&
      this.props.general.active_roles.region_id &&
      this.props.general.active_roles.school_id
    ) {
      this.fetchData();
    } else {
      this.setState({ loading: false });
    }
  }

  getRegions = groupId => {
    try {
      axios
        .get(`${URL.api}access/region/listRegionFilter/${groupId}`, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.setState({ regions: resp.data.data });
        });
    } catch {
      this.setState({
        region_id: 0
      });
    }
  };

  getSchools = (groupId, regionId) => {
    try {
      axios
        .get(
          `${URL.api}access/school/listSchoolFilter/${groupId}/${regionId}`,
          {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          }
        )
        .then(resp => {
          this.setState({ schools: resp.data.data });
        });
    } catch {
      this.setState({
        school_id: 0
      });
    }
  };

  onChangeAction = event => {
    let field = event.target.name.split("_")[0];
    let roomId = parseInt(event.target.name.split("_")[1]);
    let list = [];
    this.state.list.forEach(item => {
      list.push(item);
    });

    for (let i = 0; i < list.length; i++) {
      if (roomId === list[i].room_id) {
        if (field === "start") {
          list[i].start_allocation = event.target.value;
        } else if (field === "end") {
          list[i].end_allocation = event.target.value;
        } else if (field === "homework") {
          list[i].homework = event.target.checked;
        }
      }
    }

    this.setState({
      list
    });
  };

  onChangeUser = roomId => {
    let element = document.getElementById(`arrow_${roomId}`);

    let list = [];
    this.state.list.forEach(item => {
      list.push(item);
    });

    for (let i = 0; i < list.length; i++) {
      if (list[i].room_id === roomId) {
        list[i].show = !list[i].show;
        if (list[i].show === true) {
          element.classList.remove("fa-angle-down");
          element.classList.add("fa-angle-up");
        } else {
          element.classList.remove("fa-angle-up");
          element.classList.add("fa-angle-down");
        }
        break;
      }
    }

    this.setState({
      list
    });
  };

  onChangeCheckBoxRelease = event => {
    let roomId = parseInt(event.target.id);

    let list = [];
    this.state.list.forEach(item => {
      list.push(item);
    });

    for (let i = 0; i < list.length; i++) {
      if (roomId === list[i].room_id) {
        list[i].release = !list[i].release;
      }
    }

    this.setState({
      list
    });
  };

  onChangeCheckBoxAll = event => {
    let roomId = parseInt(event.target.id.split("_")[0]);
    let list = [];
    this.state.list.forEach(item => {
      list.push(item);
    });

    for (let i = 0; i < list.length; i++) {
      if (roomId === list[i].room_id) {
        for (let j = 0; j < list[i].users.length; j++) {
          list[i].users[j].checked = false;
        }
      }
    }

    let allocateList = [];
    for (let i = 0; i < this.state.allocateList.length; i++) {
      allocateList.push(this.state.allocateList[i]);
    }

    if (this.state.allocateList.filter(id => id === roomId).length) {
      allocateList.splice(allocateList.indexOf(roomId), 1);
    } else {
      allocateList.push(roomId);
    }
    this.setState({
      list,
      allocateList
    });
  };

  onChangeCheckBox = event => {
    let roomId = parseInt(event.target.id.split("_")[0]);
    let userId = parseInt(event.target.id.split("_")[1]);
    let list = [];
    this.state.list.forEach(item => {
      list.push(item);
    });

    let userChecked = [];

    for (let i = 0; i < list.length; i++) {
      if (roomId === list[i].room_id) {
        for (let j = 0; j < list[i].users.length; j++) {
          if (userId === list[i].users[j].id) {
            list[i].users[j].checked = !list[i].users[j].checked;
          }
          if (list[i].users[j].checked) {
            userChecked.push(list[i].users[j].id);
          }
        }
      }
    }

    let allocateList = [];
    for (let i = 0; i < this.state.allocateList.length; i++) {
      allocateList.push(this.state.allocateList[i]);
    }
    if (userChecked.length) {
      allocateList.push(roomId);
    } else {
      allocateList.splice(allocateList.indexOf(roomId), 1);
    }

    this.setState({
      list,
      allocateList
    });
  };

  allocateAction = (roomIDs, startAllocation, endAllocation, homework) => {
    if (roomIDs.length !== 1) {
      this.setState({ allocating: "main" });
    } else {
      this.setState({ allocating: roomIDs[0] });
    }

    if (startAllocation === undefined || endAllocation === undefined) {
      toastr.error("Erro", `Preencha as datas de início e fim da alocação!`);
      this.setState({ allocating: false });
      return;
    }

    if (!roomIDs?.length) {
      toastr.error("Erro", `Escolha ao menos uma turma para alocar!`);
      this.setState({ allocating: false });
      return;
    }

    const roomList = [];
    this.state.list.map(room => {
      if (roomIDs.includes(room.room_id)) {
        roomList.push(room);
      }
    });

    const shouldNotice = !roomList[0].allocation_id;

    let obj = {
      activity_id: this.state.activity_id,
      room_list: roomList
    };

    for (let i = 0; i < obj.room_list.length; i++) {
      obj.room_list[i].start_allocation = startAllocation.replace("T", " ");
      obj.room_list[i].end_allocation = endAllocation.replace("T", " ");
      obj.room_list[i].homework = homework;
    }

    for (let i = 0; i < obj.room_list.length; i++) {
      let users = [];
      for (let j = 0; j < obj.room_list[i].users.length; j++) {
        if (obj.room_list[i].users[j].checked) {
          users.push(obj.room_list[i].users[j]);
        }
      }
      obj.room_list[i].users = users;
    }

    axios
      .post(`${URL.api}activity/allocate/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState(state => ({
          list: state.list.map(room => {
            let allocationID;
            resp.data.data?.map(allocation => {
              if (allocation.room_id === room.room_id) {
                allocationID = allocation.id;
              }
            });
            return roomIDs.includes(room.room_id)
              ? {
                  ...room,
                  allocation_id: allocationID,
                  start_allocation: startAllocation,
                  end_allocation: endAllocation,
                  homework,
                  originalStart: startAllocation,
                  originalEnd: endAllocation,
                  originalHomework: homework,
                  allocatedUserIds: room.users.map(user => user.id)
                }
              : room;
          }),
          allocating: false
        }));

        if (this.state.showEditModal) {
          this.setState({ showEditModal: false });
        }

        toastr.success(
          "Alocada com sucesso!",
          "A avaliação foi alocada na turma"
        );

        if (shouldNotice) {
          let notices = [];
          for (let i = 0; i < resp.data.data.length; i++) {
            let objNotice = {
              user_id: this.props.user.user.id,
              title: "Nova avaliação alocada",
              description: `A avaliação ${
                this.state.activity.name
              } foi alocada com início definido para ${friendlyDate(
                resp.data.data[i].start
              )} e fim definido para ${friendlyDate(resp.data.data[i].end)}.`,
              type: "notification",
              activities: [resp.data.data[i].id],
              roles: [
                {
                  room_id: resp.data.data[i].room_id,
                  role_id: 7,
                  group_id: this.props.general.active_roles.group_id,
                  region_id: this.props.general.active_roles.region_id,
                  school_id: this.props.general.active_roles.school_id
                }
              ]
            };
            if (resp.data.data[i].id) {
              notices.push(objNotice);
            }
          }

          if (notices.length > 0) {
            axios
              .post(`${URL.api}communication/notice/insert`, notices[0], {
                headers: { authorization: `Bearer ${this.props.user.token}` }
              })
              .then(
                resp => {
                  this.setState({ allocating: false });
                },
                error => {
                  this.error("Não foi possível inserir o aviso dessa alocação");
                  this.setState({ allocating: false });
                }
              );
          } else {
            this.setState({ allocating: false });
          }
        }
      });
  };

  deleteAction = allocationId => {
    this.setState({ deleting: true });

    axios
      .post(
        `${URL.api}activity/allocate/delete`,
        { id: allocationId },
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          this.setState(state => ({
            list: state.list.map(room =>
              room.allocation_id === allocationId
                ? { ...room, allocation_id: 0 }
                : room
            ),
            deleting: false,
            showDeleteModal: false
          }));

          toastr.success("Apagada com sucesso!", "A alocação foi apagada");
        },
        error => {
          this.setState(state => ({
            deleting: false,
            showDeleteModal: false
          }));

          toastr.error("Falha", "Não foi possível apagar a alocação");
        }
      );
  };

  editAction = allocationId => {
    const infoClass = this.state.list.find(
      item => item.allocation_id === allocationId
    );

    const startAllocation = infoClass.start_allocation;
    const endAllocation = infoClass.end_allocation;
    const roomIds = [infoClass.room_id];

    this.allocateAction(
      roomIds,
      startAllocation,
      endAllocation,
      infoClass.homework
    );
  };

  findIndexx(obj) {
    return this.state.list.findIndex(
      current => current.room_id === obj.room_id
    );
  }

  isRoomEdited = classes => {
    if (classes.start_allocation !== classes.originalStart) return true;
    if (classes.end_allocation !== classes.originalEnd) return true;
    if (classes.homework !== classes.originalHomework) return true;

    if (classes.cAlunos) {
      const currentIds = classes.users
        .filter(user => user.checked)
        .map(user => user.id)
        .sort((a, b) => a - b);
      const originalIds = [...(classes.allocatedUserIds || [])].sort(
        (a, b) => a - b
      );

      if (currentIds.length !== originalIds.length) return true;
      for (let i = 0; i < currentIds.length; i++) {
        if (currentIds[i] !== originalIds[i]) return true;
      }
    }

    return false;
  };

  render() {
    const list = this.state.list?.filter(
      item =>
        (!this.state.group_id || item.room_group_id === this.state.group_id) &&
        (!this.state.region_id ||
          item.room_region_id === this.state.region_id) &&
        (!this.state.school_id ||
          item.room_school_id === this.state.school_id) &&
        (this.state.class === "null" ||
          item.class === (this.state.class === "true")) &&
        (!this.state.mine || !!item.mine)
    );

    const classrooms = list?.filter(item => item.class);
    const rooms = list?.filter(item => !item.class);

    const listRooms = this.state.content ? rooms : classrooms;

    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/evaluation/bank", to: "/evaluation/bank" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            {["G", "U", "R", "E"].includes(
              this.props.general.active_roles.type
            ) && (
              <CCard className="w-100">
                <CCardBody>
                  <CCol className="d-flex">
                    <div className="w-100 mr-2">
                      <div className="w-100 text-ellipsis">
                        <Label className="d-block w-100 text-ellipsis">
                          Grupo
                        </Label>
                      </div>
                      <CInputGroup className="mb-2">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-wrench"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={this.state.group_id}
                          placeholder="Grupo"
                          onChange={e => {
                            this.setState(
                              {
                                group_id: parseInt(e.target.value),
                                list: null,
                                region_id: 0,
                                school_id: 0,
                                serie_id: 0
                              },
                              () => {
                                this.fetchData(true);
                              }
                            );
                            this.getRegions(e.target.value);
                          }}
                          disabled={!!this.props.general.active_roles.group_id}
                        >
                          <option value="0">Todos</option>
                          {this.state.groups.map(item => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </div>
                    <div className="w-100 mr-2">
                      <div className="w-100 text-ellipsis">
                        <Label className="d-block w-100 text-ellipsis">
                          Regional
                        </Label>
                      </div>
                      <CInputGroup className="mb-2">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-globe"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={this.state.region_id}
                          placeholder="Regional"
                          disabled={
                            !this.state.group_id ||
                            !!this.props.general.active_roles.region_id
                          }
                          onChange={e => {
                            this.setState(
                              {
                                region_id: parseInt(e.target.value),
                                list: null,
                                school_id: 0,
                                serie_id: 0
                              },
                              () => {
                                this.fetchData(true);
                              }
                            );
                            this.getSchools(
                              this.state.group_id,
                              e.target.value
                            );
                          }}
                        >
                          <option value="0">Selecionar</option>
                          {this.state.regions?.map(item => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </div>
                    <div className="w-100 mr-2">
                      <div className="w-100 text-ellipsis">
                        <Label className="d-block w-100 text-ellipsis">
                          Escola
                        </Label>
                      </div>
                      <CInputGroup className="mb-2">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-institution"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={this.state.school_id}
                          placeholder="Escola"
                          onChange={e => {
                            if (parseInt(e.target.value) !== 0) {
                              this.setState(
                                {
                                  school_id: parseInt(e.target.value),
                                  serie_id: 0
                                },
                                () => {
                                  this.fetchData();
                                }
                              );
                            } else {
                              this.setState({
                                school_id: parseInt(e.target.value),
                                serie_id: 0,
                                list: []
                              });
                            }
                          }}
                          disabled={
                            !this.state.region_id ||
                            !!this.props.general.active_roles.school_id
                          }
                        >
                          <option value="0">Selecionar</option>
                          {this.state.schools?.map(item => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </div>
                    <div className="w-100 mr-2">
                      <div className="w-100 text-ellipsis">
                        <Label className="d-block w-100 text-ellipsis">
                          Séries
                        </Label>
                      </div>
                      <CInputGroup className="mb-2">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-institution"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={this.state.serie_id}
                          placeholder="Série"
                          onChange={e => {
                            this.setState(
                              {
                                serie_id: parseInt(e.target.value)
                              },
                              () => {
                                this.fetchData(parseInt(e.target.value));
                              }
                            );
                          }}
                          disabled={!this.state.school_id}
                        >
                          <option value="0">Selecionar</option>
                          {this.state.series?.map(item => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </div>
                    {/* <div className="w-100 text-ellipsis">
                        <Label className="d-block w-100 text-ellipsis">
                          Tipo de sala
                        </Label>
                      </div>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-users"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={this.state.class}
                          placeholder="Tipo de sala"
                          onChange={e =>
                            this.setState({ class: e.target.value })
                          }
                        >
                          <option value="null">Todas</option>
                          <option value="true">Turmas</option>
                          <option value="false">Comunidades</option>
                        </CSelect>
                      </CInputGroup> */}
                  </CCol>
                  {/* <CCol className="d-flex flex-column">
                        <div className="w-100 text-ellipsis">
                          <Label className="d-block w-100 text-ellipsis">
                            Apenas minhas
                          </Label>
                        </div>
                        <div className="flex-1 d-flex align-items-center">
                          <CSwitch
                            shape="pill"
                            color="primary"
                            checked={this.state.mine}
                            onChange={e =>
                              this.setState({ mine: e.target.checked })
                            }
                          />
                        </div>
                      </CCol> */}
                </CCardBody>
              </CCard>
            )}
            <Col md="12">
              <h3 className="mb-4">
                Aloque <strong>{this.state.activity.name}</strong>
              </h3>
              <CTabs>
                <CNav variant="tabs" className="d-flex mb-4">
                  <CNavItem onClick={() => this.setState({ content: 0 })}>
                    <CNavLink className="tab-not-focus">
                      <h4
                        className="d-inline-block mr-1 mb-0 p-1"
                        style={
                          this.state.content === 1 ? { color: "#000000" } : {}
                        }
                      >
                        Turma
                      </h4>
                    </CNavLink>
                  </CNavItem>
                  {/* <CNavItem onClick={() => this.setState({ content: 1 })}>
                    <CNavLink className="tab-not-focus">
                      <h4
                        className="d-inline-block mr-1 mb-0 p-1"
                        style={
                          this.state.content === 0 ? { color: "#000000" } : {}
                        }
                      >
                        Comunidade
                      </h4>
                    </CNavLink>
                  </CNavItem> */}
                  <div className="flex-1 d-flex justify-content-end align-items-center">
                    <span className="mr-2">Início:</span>
                    <Form.Control
                      type="datetime-local"
                      name="start"
                      value={this.state.start_allocation}
                      step="1"
                      onChange={e =>
                        this.setState({ start_allocation: e.target.value })
                      }
                      style={{ width: "16rem" }}
                    />
                    <span className="ml-3 mr-2">Fim:</span>
                    <Form.Control
                      type="datetime-local"
                      name="end"
                      value={this.state.end_allocation}
                      step="2"
                      onChange={e =>
                        this.setState({ end_allocation: e.target.value })
                      }
                      style={{ width: "16rem" }}
                    />
                    <span className="ml-3 mr-2">Para casa:</span>
                    <CSwitch
                      shape="pill"
                      color="primary"
                      checked={this.state.homework}
                      onChange={e =>
                        this.setState({ homework: e.target.checked })
                      }
                      disabled={
                        !(
                          this.state.list?.length &&
                          this.state.allocateList?.length &&
                          this.state.start_allocation &&
                          this.state.end_allocation
                        )
                      }
                    />
                    <CButton
                      color="primary"
                      className="d-flex ml-2 justify-content-center align-items-center"
                      onClick={() =>
                        this.allocateAction(
                          this.state.allocateList,
                          this.state.start_allocation,
                          this.state.end_allocation,
                          this.state.homework
                        )
                      }
                      disabled={
                        !(
                          this.state.list?.length &&
                          this.state.allocateList?.length &&
                          this.state.start_allocation &&
                          this.state.end_allocation
                        )
                      }
                    >
                      <>
                        <span
                          style={
                            this.state.allocating === "main"
                              ? { opacity: 0 }
                              : null
                          }
                        >
                          Alocar
                        </span>
                        {this.state.allocating === "main" && (
                          <CSpinner
                            size="sm"
                            color="white"
                            style={{ position: "absolute" }}
                          />
                        )}
                      </>
                    </CButton>
                  </div>
                </CNav>
              </CTabs>

              {listRooms?.length > 0 ? (
                <>
                  {listRooms?.map(classes => (
                    <CCard
                      accentColor={this.state.content ? "danger" : "primary"}
                      key={classes.room_id}
                    >
                      <CCardHeader
                        className={
                          this.state.show === classes.room_id
                            ? "d-flex align-items-center"
                            : "d-flex align-items-center rounded border-0"
                        }
                      >
                        <h4 className="m-0 p-0 flex-1 d-flex align-items-center">
                          {classes.room_name}
                          {classes.room_id_external && (
                            <span className="text-muted ml-2 small">
                              {" "}
                              ({classes.room_id_external})
                            </span>
                          )}
                          {classes.allocation_id !== 0 && (
                            <RiCheckDoubleFill className="ml-2 text-success" />
                          )}
                          {classes.allocation_id !== 0 && (
                            <CBadge color="info" className="ml-2">
                              {classes.homework ? "Casa" : "Classe"}
                            </CBadge>
                          )}
                        </h4>
                        {classes.allocation_id === 0 && (
                          <CCard
                            className={`user-card-allocate m-0${
                              (classes.users.filter(
                                user => user.checked === true
                              ).length === 0 &&
                                this.state.allocateList.filter(
                                  id => id === classes.room_id
                                ).length === 1) ||
                              (classes.users.filter(
                                user => user.checked === true
                              ).length === classes.students_count &&
                                classes.students_count !== 0)
                                ? " checked-primary"
                                : ""
                            }`}
                            onClick={() =>
                              this.onChangeCheckBoxAll({
                                target: { id: `${classes.room_id}_0` }
                              })
                            }
                          >
                            <div className="px-3 py-2 d-flex align-items-center h-100">
                              Selecionar
                            </div>
                          </CCard>
                        )}
                        {/* <CButton
                          className="text-left m-0 p-0"
                          onClick={() => this.alunosRender(classes)}
                          style={{ boxShadow: "none" }}
                        >
                          <h4
                            className="m-0 p-0 d-flex align-items-center justify-content-end"
                            style={{ width: "150px" }}
                          >
                            <span className="mr-2">
                              {classes.students_count} alunos
                            </span>
                            {this.state.show === classes.room_id ? (
                              <RiArrowUpSLine />
                            ) : (
                              <RiArrowDownSLine />
                            )}
                          </h4>
                        </CButton> */}
                      </CCardHeader>
                      <CCollapse show={this.state.show === classes.room_id}>
                        <CCardBody className="pt-3 pb-0">
                          <div
                            id={`listUser_${classes.room_id}`}
                            className="d-flex flex-wrap"
                          >
                            {classes.users.map(user => (
                              <CCard
                                className={`user-card-allocate mb-3${
                                  user.checked ? " checked" : ""
                                }`}
                                onClick={() =>
                                  this.onChangeCheckBox({
                                    target: {
                                      id: `${classes.room_id}_${user.id}`
                                    }
                                  })
                                }
                              >
                                <div className="px-3 py-2 d-flex align-items-center h-100">
                                  <img
                                    src={
                                      URL.img +
                                      (user.photo ||
                                        "uploads/users/profileEmpty.jpg")
                                    }
                                    className="rounded-circle mr-2"
                                    style={{
                                      width: "24px",
                                      height: "24px"
                                    }}
                                  />
                                  {user.name}
                                </div>
                              </CCard>
                            ))}
                          </div>
                        </CCardBody>
                      </CCollapse>
                      {classes.allocation_id !== 0 && (
                        <CCardFooter>
                          <div className="d-flex align-items-center flex-1">
                            <span className="mr-2">Início:</span>
                            <Form.Control
                              type="datetime-local"
                              name={`start_${classes.room_id}`}
                              value={classes.start_allocation}
                              step="1"
                              onChange={e => this.onChangeAction(e)}
                              style={{ width: "16rem" }}
                            />
                            <span className="ml-3 mr-2">Fim:</span>
                            <Form.Control
                              type="datetime-local"
                              name={`end_${classes.room_id}`}
                              value={classes.end_allocation}
                              step="1"
                              onChange={e => this.onChangeAction(e)}
                              style={{ width: "16rem" }}
                            />
                            <span className="ml-3 mr-2">Para casa:</span>
                            <CSwitch
                              shape="pill"
                              color="primary"
                              checked={classes.homework}
                              onChange={e =>
                                this.onChangeAction({
                                  target: {
                                    name: `homework_${classes.room_id}`,
                                    checked: e.target.checked
                                  }
                                })
                              }
                            />
                          </div>
                          <CButton
                            color="primary"
                            className="d-flex justify-content-center align-items-center ml-2"
                            disabled={
                              this.state.deleting === classes.room_id ||
                              !this.isRoomEdited(classes)
                            }
                            onClick={() =>
                              this.setState({
                                delete_id: classes.allocation_id,
                                showEditModal: true
                              })
                            }
                          >
                            <>
                              <span
                                style={
                                  this.state.deleting === classes.room_id
                                    ? { opacity: 0 }
                                    : null
                                }
                              >
                                Salvar edição
                              </span>
                              {this.state.deleting === classes.room_id && (
                                <CSpinner
                                  size="sm"
                                  color="white"
                                  style={{ position: "absolute" }}
                                />
                              )}
                            </>
                          </CButton>
                          <CButton
                            color="danger"
                            className="d-flex justify-content-center align-items-center ml-2"
                            disabled={this.state.deleting === classes.room_id}
                            onClick={() =>
                              this.setState({
                                delete_id: classes.allocation_id,
                                showDeleteModal: true
                              })
                            }
                          >
                            <>
                              <span
                                style={
                                  this.state.deleting === classes.room_id
                                    ? { opacity: 0 }
                                    : null
                                }
                              >
                                Apagar
                              </span>
                              {this.state.deleting === classes.room_id && (
                                <CSpinner
                                  size="sm"
                                  color="white"
                                  style={{ position: "absolute" }}
                                />
                              )}
                            </>
                          </CButton>
                        </CCardFooter>
                      )}
                    </CCard>
                  ))}
                </>
              ) : (
                <div className="p-5 text-center text-muted w-100">
                  {this.state.school_id ||
                  this.props.general.active_roles.school_id
                    ? "Nenhuma turma encontrada"
                    : "Selecione uma escola para realizar a alocação!"}
                </div>
              )}
            </Col>
          </Row>
        )}
        <DeleteModal
          show={this.state.showDeleteModal}
          onClose={() => this.setState({ showDeleteModal: false })}
          onDelete={() => this.deleteAction(this.state.delete_id)}
        />
        <EditModal
          show={this.state.showEditModal}
          onClose={() => this.setState({ showEditModal: false })}
          onEdit={() => this.editAction(this.state.delete_id)}
        />
        <ProtectedRoute routeId={this.props.currentRoute} />
      </React.Fragment>
    );
  }
}
class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <CModal
        color="danger"
        show={this.props.show}
        centered
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Apagar alocação</CModalHeader>
        <CModalBody>Deseja apagar a alocação?</CModalBody>
        <CModalFooter>
          <CButton color="danger" onClick={() => this.props.onDelete()}>
            Confirmar
          </CButton>
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>,
      this.el
    );
  }
}

class EditModal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <CModal
        color="primary"
        show={this.props.show}
        centered
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Alterar alocação</CModalHeader>
        <CModalBody>Deseja alterar a alocação?</CModalBody>
        <CModalFooter>
          <CButton color="primary" onClick={() => this.props.onEdit()}>
            Confirmar
          </CButton>
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>,
      this.el
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationBankAllocate);
